module.exports = "@media (max-width: 400px) {\r\n    .checkbox-text {\r\n        width: 80%;\r\n    }\r\n}\r\n\r\n@media (max-width: 450px) {\r\n    input[type=\"radio\"] {\r\n        margin-top: 0;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/business-calculator/air-travel/air-travel-default/air-travel-default.component.css
// module id = ./src/app/components/calculator/calculator-item/business-calculator/air-travel/air-travel-default/air-travel-default.component.css
// module chunks = main